@if (notification(); as n) {
  <hlm-dialog [state]="visible() ? 'open' : 'closed'" (closed)="close()">
    <hlm-dialog-content
      class="w-[28rem]"
      showCloseButton="false"
      *brnDialogContent
    >
      <div>
        <!-- Ícone e Header -->
        <div class="flex items-start gap-4">
          <div class="flex-1 min-w-0">
            <div class="flex gap-2">
              <div
                [class]="
                  'flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center ' +
                  modalConfig().bgClass
                "
              >
                <ng-icon
                  [name]="modalConfig().icon"
                  [class]="'text-2xl ' + modalConfig().iconClass"
                />
              </div>
              <div class="flex flex-col">
                <span
                  [class]="
                    'text-xs font-medium uppercase tracking-wider ' +
                    modalConfig().headerClass
                  "
                >
                  {{ modalConfig().titleKey | translate }}
                </span>
                <h3
                  class="text-lg font-semibold text-foreground"
                >
                  {{ n.title }}
                </h3>
              </div>
            </div>

            <!-- Mensagem -->
            <p class="mt-2 text-sm text-muted-foreground">
              {{ n.message }}
            </p>
          </div>
        </div>

        <!-- Ações -->
        <div class="mt-6 flex justify-end gap-3">
          @if (n.link) {
            <button hlmBtn variant="ghost" (click)="goToLink()">
              {{
                "shared.dialogs.notificationError.buttons.details" | translate
              }}
              <ng-icon name="lucideArrowRight" />
            </button>
          }
          <button hlmBtn class="ml-auto" (click)="close()">
            {{ "shared.dialogs.notificationError.buttons.close" | translate }}
          </button>
        </div>
      </div>
    </hlm-dialog-content>
  </hlm-dialog>
}
